import React from 'react';

import Background from '../images/background-2.png';

import '../style/home2.css';

function Home2() {
  return (
    <div className="middle-3">
      <div className="container-all">
        <img alt="Background 2" style={{ width: '100%', position: 'relative' }} className="background-1" src={Background} />
        <div className="centered">
          <h2 style={{ color: '#fff' }}>Mas Por Que Escolher a Alliance?</h2>
          <br />
          <ul>
            <li>Comboios Diários</li>
            <li>Eventos Utilizando o Trucksbook</li>
            <li>Ambiente Amigável</li>
          </ul>
          <p style={{ color: '#fff' }}>Gostou? Então Venha Participar da Alliance:</p>
          <p><a className="apply" href="/apply">Venha para a Alliance</a></p>
        </div>
      </div>
    </div>
  );
}

export default Home2;
